// Mock data for TweePorter.ca Website Platform

export const mockUser = {
  id: '1',
  name: 'Demo User',
  email: 'demo@tweeporter.com',
  createdAt: '2025-01-15T10:00:00Z'
};

export const mockProjects = [
  {
    id: 'proj-1',
    title: 'Fantasy Adventure',
    description: 'An epic quest through mystical lands',
    createdAt: '2025-01-20T14:30:00Z',
    updatedAt: '2025-01-22T09:15:00Z',
    passages: 24,
    versions: 12,
    lastEdited: '2 hours ago',
    content: `:: StoryTitle
Fantasy Adventure

:: Start
You stand at the entrance of a dark forest. The trees loom overhead, their branches creating intricate patterns against the sky.

[[Enter the forest->Forest]]
[[Turn back->Village]]

:: Forest
The forest is darker than you expected. Strange sounds echo through the trees.

[[Continue deeper->DeepForest]]
[[Return to entrance->Start]]

:: Village
You return to the safety of the village.

[[Rest at the inn]]
[[Visit the market]]

:: DeepForest
You've ventured deep into the forest. A mysterious glow appears in the distance.

The End (for now)`
  },
  {
    id: 'proj-2',
    title: 'Sci-Fi Mystery',
    description: 'Uncover secrets aboard a space station',
    createdAt: '2025-01-18T11:20:00Z',
    updatedAt: '2025-01-21T16:45:00Z',
    passages: 18,
    versions: 8,
    lastEdited: '1 day ago',
    content: `:: StoryTitle
Sci-Fi Mystery

:: Start
The space station's alarm blares. Red emergency lights pulse through the corridors.

[[Check the control room]]
[[Head to engineering]]`
  },
  {
    id: 'proj-3',
    title: 'Horror House',
    description: 'Survive the night in a haunted mansion',
    createdAt: '2025-01-15T08:00:00Z',
    updatedAt: '2025-01-15T10:30:00Z',
    passages: 8,
    versions: 3,
    lastEdited: '1 week ago',
    content: `:: StoryTitle
Horror House

:: Start
The old mansion creaks as you push open the door.

[[Enter->Hallway]]`
  }
];

export const mockVersions = [
  {
    id: 'v-1',
    projectId: 'proj-1',
    versionNumber: 12,
    timestamp: '2025-01-22T09:15:00Z',
    label: 'Latest',
    changes: 'Added deep forest passage'
  },
  {
    id: 'v-2',
    projectId: 'proj-1',
    versionNumber: 11,
    timestamp: '2025-01-21T15:30:00Z',
    label: 'Auto-save',
    changes: 'Modified village passage'
  },
  {
    id: 'v-3',
    projectId: 'proj-1',
    versionNumber: 10,
    timestamp: '2025-01-20T18:45:00Z',
    label: 'Checkpoint',
    changes: 'Initial forest structure'
  }
];

export const mockAssets = [
  {
    id: 'asset-1',
    projectId: 'proj-1',
    name: 'forest-bg.jpg',
    type: 'image/jpeg',
    size: 245000,
    uploadedAt: '2025-01-20T14:35:00Z'
  },
  {
    id: 'asset-2',
    projectId: 'proj-1',
    name: 'ambient-music.mp3',
    type: 'audio/mpeg',
    size: 1850000,
    uploadedAt: '2025-01-20T15:20:00Z'
  }
];
